import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { useLenis } from "@/hooks/useLenis";
import HomePage from "@/pages/Home";
import ProductsPage from "@/pages/Products";
import CataloguePage from "@/pages/Catalogue";
import AboutPage from "@/pages/About";
import ContactPage from "@/pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, [pathname]);
    return null;
};

const Shell = () => {
    useLenis();
    return (
        <>
            <ScrollToTop />
            <Nav />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/catalogue" element={<CataloguePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="*" element={<HomePage />} />
            </Routes>
            <Footer />
        </>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Shell />
            </BrowserRouter>
        </div>
    );
}

export default App;
